export const DEFAULT_SORT = "recommended";
export const DEFAULT_PER_PAGE = 96;
export const DEFAULT_CURRENT_PAGE = 1;

export enum SystemFilterKeys {
  SORT = "sort",
  PAGE = "currentPage",
  PER_PAGE = "perPage",
  SEARCH = "search",
}

export const SYSTEM_KEYS = new Set<string>([
  SystemFilterKeys.SORT,
  SystemFilterKeys.PAGE,
  SystemFilterKeys.PER_PAGE,
  SystemFilterKeys.SEARCH,
]);
